import { render } from "./ReferesDatatable.vue?vue&type=template&id=13c3f65e"
import script from "./ReferesDatatable.vue?vue&type=script&lang=js"
export * from "./ReferesDatatable.vue?vue&type=script&lang=js"

import exportComponent from "/opt/referents/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__